import React, { useState, useEffect, useRef } from "react";
import InputBox from "../../components/InputBox";
import {
  getPredictLimits,
  getPredictionData,
  getPredictionStatus,
  predictionCalculation,
} from "../../network/cipAPI";
import DupontButton from "../../components/DupontButton";
import PageLoading from "../../components/PageLoading";
import { OverlayLoader } from "../../components/PageLoading";
import BoxCompontent from "../../components/BoxComponent";
import { useDispatch, useSelector } from "react-redux";
import {
  storeForcastWindow,
  storePredictionData,
} from "../../Store/TemplateStore/template.action";
import CriticalDeleteDialog from "../../components/CriticalDeleteDialog";
import { TextFieldValidator } from "../../components/InputBox/TextFieldValidator";
import AgTable from "../../components/AgTable";
import {
  dateFormatter,
  formattedCurrencyValue,
} from "../../utils/tableDataFormatter";
import createNotification, {
  ERROR_NOTIFICATION,
} from "../../components/Notifications";
import { NotificationManager } from "react-notifications";

import moment from "moment";
import PopoverText from "../../components/PopoverText";
import InfoIconGreen from "../../assets/info-icon-green.svg";
import {
  getSortedData,
  typeFormatter,
  multipleReasonFormatter,
} from "../../utils/tableDataFormatter";
import exportAllTables from "../../XLSDownload/ExportAllTables/index.js";
import ExportAllData from "./exportAllData";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { API_URLS } from "../../network/appUrls";
import AdvanceSettings from "../analyseData/advancedSettings";
import { DIALOG_TYPES } from "../../packages/ConfirmationPopup/index.js";
import ConfirmationPopup from "../../packages/ConfirmationPopup/index.js";
import {
  CustomModalButtons,
  CIP_MISSING_VALIDATION,
} from "../../constants/global.constants.js";
const PredictCIP = ({ setDisableNextButton }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const intervalIdRef = useRef(null);
  const [forecastDays, setForecastDays] = useState(
    useSelector((state) => state.forecastWindow)
  );
  const [isSettingsDialogOpen, setIsSettingsDialogOpen] = useState(false);
  const [limitWindow, setLimitWindow] = useState(null);
  const [showValidationWarning, setShowValidationWarning] = useState(false);
  const [foulingType, setfoulingType] = useState(
    useSelector((state) => state.foulingType)
  );
  const [predictionData, setPredictionData] = useState(
    useSelector((state) => state.predictionData)
  );
  const [isOutSideRange, setIsOutsideRange] = useState(false);
  const [isOutsideSoftLimit, setIsOutsideSoftLimit] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [rowData, setRowData] = useState(null);
  const [errorMsgFailedPrediction, setErrorMsgFailedPrediction] =
    useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [processedPercentage, setprocessedPercentage] = useState(false);
  const [showOverlayLoader, setShowOverlayLoader] = useState(false);
  const plantLocation = useSelector((state) => state.plantLocation);
  const plantName = useSelector((state) => state.plantName);
  const [taskId, setTaskId] = useState(null);
  const selectedTrain = useSelector((state) => state.selTrain);

  const handleSettingsDialog = (open) => {
    setIsSettingsDialogOpen(open);
  };

  const handleSettingsSave = () => {
    // If prediction data already exists, rerun the prediction with new settings
    if (predictionData && forecastDays) {
      // Clear existing task ID to force a new calculation
      setTaskId(null);
      // Trigger new prediction
      callPredict();
    }
  };
  const setTotalbenefitWindow = () => {
    return `${moment(limitWindow?.["max_date"]).format(
      "DD/MM/YYYY"
    )} - ${moment(limitWindow?.["max_date"])
      .add("days", forecastDays)
      .format("DD/MM/YYYY")}`;
  };
  const setAnnualbenefitWindow = () => {
    return ` ${moment(limitWindow?.["max_date"]).format(
      "DD/MM/YYYY"
    )} - ${moment(limitWindow?.["max_date"])
      .add("year", 1)
      .format("DD/MM/YYYY")}`;
  };
  const allData = ExportAllData();
  const [exportAllData, setExportAllData] = useState({
    ...allData,
    predictionDataRaw: predictionData,
    predictionandRecommendData: rowData,
  });
  const [exportAllSheetName, setExportAllSheetName] = useState(
    `${plantLocation.trim()}_${plantName.trim()}_${moment().format(
      "MM/DD/YYYY"
    )}_${t("predictionStrings.cleaningAdvisorReport")}`
  );
  const dispatch = useDispatch();

  const annualTotalFinancialBenefits = predictionData
    ? parseInt(predictionData["annual_total_financial_benefits"])
    : 0;

  const totalFinancialBenefits = predictionData
    ? parseInt(predictionData["total_financial_benefits"])
    : 0;

  const getIndex = (params, column) => {
    return column ? params.node.rowIndex + 1 : "";
  };

  const formatDate = (params, date) => {
    return date ? dateFormatter(params) : "";
  };

  const reasonFormatter = (type) => {
    if (typeof type === "string" && type.trim() !== "") {
      type = type.split(",");
      const formattedType = type.map((item) =>
        foulingType ? foulingType[item.trim()] : item.trim()
      );
      const resultString = formattedType.join(", ");
      return resultString || type;
    }
  };
  const handleValidationWarningClose = (buttonId) => {
    setShowValidationWarning(false);
    // Clear any existing notifications
    NotificationManager.removeAll();

    if (buttonId === CustomModalButtons.CANCEL) {
      callPredict(true);
    } else if (buttonId === CustomModalButtons.CONFIRM) {
      // Preserve existing query parameters
      const currentParams = window.location.search;
      navigate(`${API_URLS.basePath}analyseData${currentParams}`, {
        state: { showRecurrent: true },
      });
    }
  };
  const colDef = [
    {
      headerName: t("predictionStrings.predictedSchedule"),
      headerClass: "my-css-class",
      children: [
        {
          headerName: t("predictionStrings.index"),
          field: "predictedItem.index",
          valueGetter: (params) =>
            getIndex(params, params.data.predictedItem.start_date),
          flex: 1,
        },
        {
          headerName: t("predictionStrings.type"),
          field: "predictedItem.type",
          valueFormatter: (params) => typeFormatter(params, t),
          sortable: true,
          flex: 1,
        },
        {
          headerName: t("predictionStrings.startDate"),
          field: "predictedItem.start_date",
          sortable: true,
          flex: 1.5,
          valueFormatter: (params) =>
            formatDate(params, params.data.predictedItem.start_date),
        },
        {
          headerName: t("predictionStrings.reason"),
          field: "predictedItem.reason",
          sortable: true,
          flex: 2,
          wrapText: true,
          autoHeight: true,
          valueFormatter: (params) =>
            multipleReasonFormatter(params.data.predictedItem.reason),
          valueGetter: (params) =>
            multipleReasonFormatter(params.data.predictedItem.reason),
        },
      ],
    },
    {
      headerName: t("predictionStrings.recommendedSchedule"),
      headerClass: "my-css-class",
      children: [
        {
          headerName: t("predictionStrings.index"),
          field: "recommendedItem.index",
          valueGetter: (params) =>
            getIndex(params, params.data.recommendedItem.start_date),
          flex: 1,
        },
        {
          headerName: t("predictionStrings.type"),
          field: "recommendedItem.type",
          sortable: true,
          valueFormatter: (params) => typeFormatter(params, t),
          flex: 1,
        },
        {
          headerName: t("predictionStrings.startDate"),
          field: "recommendedItem.start_date",
          sortable: true,
          flex: 1.5,
          valueFormatter: (params) =>
            formatDate(params, params.data.recommendedItem.start_date),
        },
        {
          headerName: t("predictionStrings.reason"),
          field: "recommendedItem.reason_recommended",
          sortable: true,
          flex: 2,
          wrapText: true,
          autoHeight: true,
          valueFormatter: (params) =>
            multipleReasonFormatter(
              params.data.recommendedItem.reason_recommended
            ),
          valueGetter: (params) =>
            multipleReasonFormatter(
              params.data.recommendedItem.reason_recommended
            ),
        },
      ],
    },
  ];

  const financialBenefits = {
    energy_saving: t("predictionStrings.energySaving"),
    chemical_saving: t("predictionStrings.chemicalSaving"),
    downtime_saving: t("predictionStrings.downtimeSaving"),
    increased_production: t("predictionStrings.waterProduction"),
  };

  const annualBenefits = {
    annual_energy_saving: t("predictionStrings.energySaving"),
    annual_chemical_saving: t("predictionStrings.chemicalSaving"),
    annual_downtime_saving: t("predictionStrings.downtimeSaving"),
    annual_increased_production: t("predictionStrings.waterProduction"),
  };

  const onForecastDaysChange = (value) => {
    if (value) setForecastDays(parseInt(value));
    else {
      setForecastDays(null);
    }
  };
  const onBackClicked = () => {
    setIsOutsideRange(false);
    setIsLoading(false);
  };

  const checkStatus = async (task_id) => {
    try {
      let id = task_id || taskId;
      let predictionStatus;
      if (id === "" || id === null || id === undefined) {
        predictionStatus = { data: { status: "pending" } };
      } else {
        predictionStatus = await getPredictionStatus(id);
      }

      try {
        const status = predictionStatus?.data?.status?.toLowerCase();
        if (status === "completed") {
          if (intervalIdRef.current) {
            clearInterval(intervalIdRef.current);
            intervalIdRef.current = null;
          }
          setShowOverlayLoader(false);
          setTaskId("");

          const predicitionData = await getPredictionData(
            selectedTrain,
            forecastDays
          );
          setIsLoading(false);
          setDisableNextButton(false);
          if (predicitionData?.data["modeling"]) {
            const d = predicitionData?.data["modeling"].replaceAll(
              "-Infinity",
              '"-Infinity"'
            );

            const parsedData = JSON.parse(d);

            setPredictionData(parsedData);
            setIsLoading(false);
            setDisableNextButton(false);
            dispatch(storePredictionData(parsedData));
            setErrorMsgFailedPrediction("");
          }
        } else if (status === "pending") {
          setIsLoading(false);
          setShowOverlayLoader(false);
          if (intervalIdRef.current) {
            clearInterval(intervalIdRef.current);
            intervalIdRef.current = null;
          }
          setDisableNextButton(false);
          setprocessedPercentage("");
        } else if (status === "running") {
          setprocessedPercentage(predictionStatus?.data.processed);
          setIsLoading(true);
          setShowOverlayLoader(false);
          setDisableNextButton(true);
          setErrorMsgFailedPrediction("");
        } else if (status === "failed") {
          setprocessedPercentage("");
          setShowOverlayLoader(false);
          setErrorMsgFailedPrediction(t("predictionStrings.failedPrediction"));
          setIsLoading(false);
          setDisableNextButton(false);
          if (intervalIdRef.current) {
            clearInterval(intervalIdRef.current);
            intervalIdRef.current = null;
          }
          createNotification(
            ERROR_NOTIFICATION,
            t("predictionStrings.failedPrediction"),
            ""
          );
          setTaskId("");
        }
        return status;
      } catch (err) {
        return "failed";
      }
    } catch (err) {
      if (err.code === "ERR_NETWORK" || err.response.status === 502) {
        console.log("Error is " + err);
      } else {
        if (intervalIdRef.current) {
          clearInterval(intervalIdRef.current);
          intervalIdRef.current = null;
        }
        setIsLoading(false);
        setShowOverlayLoader(false);
        setDisableNextButton(false);
        setprocessedPercentage("");
        if (rowData === null)
          setErrorMsgFailedPrediction(t("predictionStrings.errorPrediction"));
        console.log("Error is " + err);
        setTaskId("");
        return "failed";
      }
    }
  };

  useEffect(() => {
    setShowOverlayLoader(true);
    setDisableNextButton(true);
    checkStatus();

    // Cleanup function to clear interval when component unmounts
    return () => {
      if (intervalIdRef.current) {
        clearInterval(intervalIdRef.current);
        intervalIdRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    const totalBenefitWindow = setTotalbenefitWindow();
    const annualBenefitsWindow = setAnnualbenefitWindow();

    setExportAllData({
      ...exportAllData,
      predictionandRecommendData: rowData,
      totalbenefitWindow: totalBenefitWindow,
      annualBenefitsWindow: annualBenefitsWindow,
      predictionDataRaw: predictionData,
    });
  }, [exportAllData]);

  useEffect(() => {
    if (forecastDays && predictionData) {
      const rowData = [];
      const maxLength = Math.max(
        predictionData["recommended_cip_start_date"].length,
        predictionData["predicted_cip_start_date"].length
      );

      for (let i = 0; i < maxLength; i++) {
        const recommendedItem = {
          start_date: predictionData["recommended_cip_start_date"][i] || null,
          reason_recommended: predictionData["recommend_cip_reason"][i] || null,
          reason: null,
          type: predictionData["recommended_cip_type"][i] || null,
        };

        const predictedItem = {
          start_date: predictionData["predicted_cip_start_date"][i] || null,
          reason: predictionData["predicted_cip_reason"][i] || null,
          type: predictionData["predicted_cip_types"][i] || null,
        };

        rowData.push({ recommendedItem, predictedItem });
      }
      const sortedData = getSortedData(rowData);
      setRowData(sortedData);
    }
  }, [predictionData]);

  const callPredict = async (proceedOnMissing = false) => {
    setErrorMsgFailedPrediction(null);
    dispatch(storePredictionData(null));
    dispatch(storeForcastWindow(forecastDays));
    setRowData(null);
    setPredictionData(null);
    setIsLoading(true);
    let task_id = taskId;

    try {
      if (!taskId) {
        const calculation = await predictionCalculation(
          parseInt(forecastDays),
          selectedTrain,
          proceedOnMissing
        );
        task_id = calculation?.data?.task_id;
        setTaskId(task_id);
        if (
          calculation?.status === 400 &&
          calculation?.data?.detail?.key?.includes(
            CIP_MISSING_VALIDATION.ERROR_KEY
          )
        ) {
          createNotification(
            ERROR_NOTIFICATION,
            calculation?.data?.detail?.error,
            ""
          );
          setShowValidationWarning(true);
        } else if (calculation?.status == 400 || calculation?.status == 422) {
          createNotification(ERROR_NOTIFICATION, calculation?.data?.error, "");
          setIsLoading(false);
          setDisableNextButton(false);
          return;
        }
        // Only start interval if we have a valid task_id
        if (task_id) {
          checkStatus(task_id);
          intervalIdRef.current = setInterval(function () {
            // Always use the captured task_id from closure
            if (task_id) {
              checkStatus(task_id);
            }
          }, 15000);
          setDisableNextButton(true);
          setprocessedPercentage("1%");
        } else {
          setIsLoading(false);
          setDisableNextButton(false);
        }
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const onPredictClicked = async () => {
    try {
      if (
        forecastDays &&
        parseInt(forecastDays) > parseInt(limitWindow.soft_limit) &&
        parseInt(forecastDays) <= parseInt(limitWindow.hard_limit)
      ) {
        setIsOutsideSoftLimit(true);
        return;
      } else if (forecastDays > limitWindow.hard_limit) {
        setIsOutsideRange(true);
        return;
      } else if (!forecastDays) {
        setErrorMsg(t("predictionStrings.forecastError"));
        return;
      }
      await callPredict();
    } catch (err) {}
  };

  const onProceedClicked = async (value) => {
    setIsOutsideSoftLimit(false);
    if (value.action === "CONFIRM") {
      await callPredict();
    } else {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const fetchLimit = async () => {
      try {
        const limits = await getPredictLimits(selectedTrain);
        if (limits.data) {
          setLimitWindow(limits.data);
          // Check for previous_prediction and set forecast window and prediction data if present
          if (limits.data.previous_prediction) {
            const previous_value = limits.data.previous_prediction;
            if (previous_value.forecast_window) {
              setForecastDays(Math.ceil(previous_value.forecast_window));
            }
            if (previous_value.modeling) {
              const parsedResult = JSON.parse(previous_value.modeling);
              setPredictionData(parsedResult);
            }
          } else if (!forecastDays) {
            setForecastDays(Math.ceil(limits.data.default_limit));
          }
        }
      } catch (err) {}
    };

    fetchLimit();
  }, []);

  const formattedCurrency = (value) => {
    return value < 0
      ? `- ${formattedCurrencyValue(value, exportAllData.others[0].currency)}`
      : `${formattedCurrencyValue(value, exportAllData.others[0].currency)}`;
  };

  return (
    <div style={{ marginTop: 20 }}>
      {showOverlayLoader && <OverlayLoader customHeight={"350px"} />}
      <div>
        <div className="descriptionText" id="predict-description">
          {t("predictionStrings.predictDescription")}
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "flex-end",
            marginTop: "20px",
            justifyContent: "space-between",
          }}
        >
          <div className="d-flex flex-end">
            <InputBox
              id="forecast-days"
              value={forecastDays}
              labelText={t("predictionStrings.forecastWindow")}
              onChange={onForecastDaysChange}
              isRequired
              errorMsg={errorMsg}
              disabled={isLoading}
              hideClearBtn={isLoading}
              customClass="width30 dupont-form-label"
              validator={TextFieldValidator.NUMBER_ONLY}
            />
            <DupontButton
              id="predict-button"
              onClick={onPredictClicked}
              customClass="margin-left-10"
              disabled={!forecastDays || isLoading}
            >
              {t("predictionStrings.predict")}
            </DupontButton>
          </div>
          <div>
            <DupontButton
              id="export-predict-button"
              onClick={() =>
                exportAllTables(
                  exportAllSheetName,
                  exportAllData,
                  foulingType,
                  t
                )
              }
              customClass="margin-left-10"
              disabled={predictionData === null || isLoading}
            >
              {t("predictionStrings.exportAll")}
            </DupontButton>
          </div>
        </div>
        {limitWindow && (
          <div className="descriptionText marginTop5" id="recommended-range">
            {t("predictionStrings.recommendedRange")}-{" "}
            {parseInt(limitWindow.soft_limit)},
            {t("predictionStrings.upperLimit")}-{" "}
            {parseInt(limitWindow.hard_limit)}
          </div>
        )}

        {isLoading ? (
          <PageLoading
            customHeight={150}
            iconHeight={"height--100"}
            message={t("ValueStrings.loaderMessage")}
            percentage={processedPercentage}
          ></PageLoading>
        ) : (
          <div>
            <div style={{ display: "flex", marginTop: 10, marginBottom: 10 }}>
              {rowData && (
                <div style={{ flex: 1 }} id="predict-table">
                  <AgTable
                    rowData={rowData}
                    columnDefs={colDef}
                    domLayout="autoHeight"
                    name={`${t("excelSheetNames.predict")}.csv`}
                  />
                </div>
              )}
            </div>
            {errorMsgFailedPrediction && (
              <div
                style={{}}
                className="errorMsg"
                id="error-msg-failed-prediction"
              >
                {errorMsgFailedPrediction}
              </div>
            )}
            {predictionData && totalFinancialBenefits > 0 && (
              <>
                <div
                  className="bodyMainHeadingText marginTop10"
                  style={{ color: "teal" }}
                >
                  {" "}
                  {t("predictionStrings.projectedWindow")} - (
                  {setTotalbenefitWindow()})
                </div>

                <div
                  className="bodyMainHeadingText marginTop10 blackBorder flex-ai-center"
                  id="total-financial-benefits"
                >
                  {t("predictionStrings.totalFinancialBenefits")}
                  {
                    <PopoverText
                      descriptor={<img src={InfoIconGreen} alt="icon" />}
                      descriptionText={t("predictionStrings.totalBenefitNote")}
                    />
                  }
                  : {formattedCurrency(totalFinancialBenefits)}
                </div>

                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  {Object.entries(financialBenefits).map(([key, value]) => (
                    <BoxCompontent
                      title={value}
                      value={predictionData[key + "_dollars"]}
                      percentageValue={predictionData[key + "_percent"]}
                      volume={predictionData[key]}
                      id={`${key}-box-component`}
                    />
                  ))}
                </div>
              </>
            )}

            {predictionData &&
              predictionData.forcast_window < 365 &&
              predictionData.forcast_window > 183 &&
              annualTotalFinancialBenefits > 0 && (
                <div>
                  <div
                    className="bodyMainHeadingText marginTop10 "
                    style={{ color: "teal" }}
                  >
                    {" "}
                    {t("predictionStrings.projectedAnnualBenefits")} - (
                    {setAnnualbenefitWindow()} ){" "}
                  </div>
                  <div
                    className="bodyMainHeadingText marginTop10 blackBorder flex-ai-center"
                    id="total-annual-benefits"
                  >
                    {t("predictionStrings.totalAnnualBenefits")}
                    {
                      <PopoverText
                        descriptor={<img src={InfoIconGreen} alt="icon" />}
                        descriptionText={t(
                          "predictionStrings.annualBenefitNote"
                        )}
                      />
                    }
                    : {formattedCurrency(annualTotalFinancialBenefits)}
                  </div>
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    {Object.entries(annualBenefits).map(([key, value]) => (
                      <BoxCompontent
                        title={value}
                        value={predictionData[key + "_dollars"]}
                        percentageValue={predictionData[key + "_percent"]}
                        volume={predictionData[key]}
                        id={`${key}-box-component`}
                      />
                    ))}
                  </div>
                </div>
              )}

            {predictionData &&
              annualTotalFinancialBenefits <= 0 &&
              totalFinancialBenefits <= 0 && (
                <div
                  className="errorMsg margin-top-20 blackBorder"
                  id="no-data-error"
                >
                  {t("predictionStrings.noData")}
                </div>
              )}
          </div>
        )}

        {isOutSideRange && (
          <CriticalDeleteDialog
            id="outside-range-error-dialog"
            type="error"
            title={t("predictionStrings.forecastedDays")}
            description={t("predictionStrings.forecastDescription")
              .replace("<forecastDays>", forecastDays)
              .replace("<HardLimit>", parseInt(limitWindow.hard_limit))}
            onDialogClose={onBackClicked}
            cancelBtnText={t("ValueStrings.cancel")}
          />
        )}

        {isOutsideSoftLimit && (
          <CriticalDeleteDialog
            id="outside-soft-limit-warning-dialog"
            type="warning"
            cancelBtnText={t("ValueStrings.cancel")}
            confirmBtnText={t("ValueStrings.proceed")}
            title={t("predictionStrings.proceedConfirmation")}
            description={t("predictionStrings.lowerForecastDescription")
              .replace("<forecastDays>", forecastDays)
              .replace("<HardLimit>", parseInt(limitWindow.soft_limit))}
            onDialogClose={onProceedClicked}
          />
        )}
        <DupontButton
          customClass="fixed-settings-btn"
          onClick={() => handleSettingsDialog(true)}
          disabled={isLoading}
        >
          {t("analyseData.settings")}
        </DupontButton>
        {isSettingsDialogOpen && (
          <AdvanceSettings
            isSettingsDialogOpen={isSettingsDialogOpen}
            handleSettingsDialogClose={() => handleSettingsDialog(false)}
            selectedTrain={selectedTrain}
            cipPredictionAndRecommendation
            lifetime
            onSave={handleSettingsSave}
          />
        )}

        {showValidationWarning && (
          <ConfirmationPopup
            open={showValidationWarning}
            type={DIALOG_TYPES.WARNING}
            header={t("CIPEvent.missingCIPHeader")}
            description={t("predictionStrings.predictionMissingCIPDescription")}
            onClose={handleValidationWarningClose}
            cancelBtn={t("CIPEvent.missingCIPCancelBtn")}
            confirmBtn={t("predictionStrings.updateSchedule")}
            customBackdrop={true}
          ></ConfirmationPopup>
        )}
        {rowData && <div className="RO-disclaimer">{t("disclaimer")}</div>}
      </div>
    </div>
  );
};

export default PredictCIP;
